import { Divider, Grid, LinearProgress, Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useApiQuery } from "../../../../../../hooks/use-api-query";
import { Alert } from "../../../../../ui";
import { BackButton } from "../elements/buttons";
import TradeButton from "../elements/buttons/trade";
import PessoaData from "../elements/pessoa/data";
import PessoasTable from "../elements/pessoa/table";
import { useInvisibleReCAPTCHA } from "../../../../../../hooks/useInvisibleReCAPTCHA";
import InvisibleReCAPTCHA from "../../../../../ui/InvisibleReCAPTCHA";

const typeVariations = {
  credor: { singular: "CREDOR", plural: "CREDORES" },
  representante: { singular: "REPRESENTANTE", plural: "REPRESENTANTES" },
};

const PessoasArea = ({ precatorio, type }) => {
  const [captchaToken, setCaptchaToken] = useState();
  const [pessoa, setPessoa] = useState();
  const [document, setDocument] = useState();
  const data = precatorio[typeVariations[type].plural.toLowerCase()] || [];
  const title = typeVariations[type][data.length <= 1 ? "singular" : "plural"];

  const {
    isExecuting: isExecutingCaptcha,
    ref: captchaRef,
    executeAsync: executeCaptchaAsync,
  } = useInvisibleReCAPTCHA();

  const {
    data: assertiva,
    isLoading: loadingAssertiva,
    isError: assertivaError,
  } = useApiQuery(
    [
      "pessoas",
      "fetch_assertiva",
      { id: pessoa?.pessoa?.id, document, captcha_token: captchaToken },
    ],
    {
      useQueryOptions: {
        enabled: !!captchaToken && (!!pessoa || !!document),
      },
    }
  );

  const { pessoas: assertivaPessoas } = assertiva || {};

  const verifyCaptcha = async () => {
    const captchaToken = await executeCaptchaAsync();
    setCaptchaToken(captchaToken);
  };

  useEffect(() => {
    pessoa && verifyCaptcha();
  }, [pessoa]);

  const backToTable = () => {
    setPessoa();
    setDocument();
  };

  const isLoading = isExecutingCaptcha || loadingAssertiva;

  return (
    <Paper elevation={5} style={{ marginBottom: "24px" }}>
      <Grid container style={{ padding: "0 24px" }}>
        <Grid item xs={12}>
          {pessoa && (
            <div className="qd-buttons">
              {(pessoa || document) && <BackButton backToTable={backToTable} />}

              <TradeButton
                disabled={isLoading}
                type={type}
                model={pessoa}
                assertiva={assertiva}
                precatorio={precatorio}
              />
            </div>
          )}

          <Divider className="mb-30" />

          <InvisibleReCAPTCHA ref={captchaRef} />

          {isLoading && (
            <Alert
              title="ENRIQUECENDO DADOS"
              message={<LinearProgress />}
              severity="info"
              variant="outlined"
            />
          )}

          <h4
            className={`qd-area-title${pessoa ? "" : " mt-30"}${
              isLoading ? " mt-30" : ""
            }`}
          >
            {pessoa ? `DADOS DE ${typeVariations[type].singular}` : title}
          </h4>
        </Grid>

        {pessoa ? (
          <>
            <Grid style={{ padding: "8px 8px 16px" }} container>
              <PessoaData
                assertiva={assertiva}
                onClickBack={() => setDocument()}
                data={pessoa}
              />

              {assertivaError && (
                <>
                  <Divider className="mt-20 mb-20 w-100" />

                  <Alert
                    title="ATENÇÃO"
                    message={`Não conseguimos enriquecer os dados de ${pessoa.pessoa.nome}`}
                    severity="warning"
                    variant="outlined"
                  />
                </>
              )}
            </Grid>

            {assertivaPessoas && (
              <Grid style={{ paddingBottom: "20px" }} container>
                <Divider className="mt-20 mb-20 w-100" />

                <PessoasTable
                  type="homônimos"
                  data={assertivaPessoas}
                  onViewDetails={setDocument}
                />
              </Grid>
            )}
          </>
        ) : (
          <PessoasTable
            type={type == "credor" ? "credores" : "representantes"}
            data={data}
            onViewDetails={setPessoa}
          />
        )}
      </Grid>
    </Paper>
  );
};

export default PessoasArea;
